export default {
    setCategories(state, payload) { 
        state.categories = payload;
    },

    setFormatCategories(state, payload) { 
        state.format_category = payload;
    },

    setIndustrialCategories(state, payload) {
        state.industrial_category = payload;
    },

    setInterchangeSku(state, payload) {
        state.interchange_sku = payload;
    },
    setInterchangeManufacturers(state, payload) {
        state.interchange_manufacturers = payload;
    },

    setWhi_smart_url(state, payload){
        state.whi_smart_url = payload;
    },

    setWhi_product(state, payload){
        state.whi_product = payload;
    },

    setCustom_attr(state, payload) {
        state.custom_attrs = payload;
    },

    setFilter_attr(state, payload) {
        state.filter_attr = payload;
    },

}